import { useState } from "react";
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from "framer-motion";
import { Zap } from "lucide-react";
import { PRICE } from "./shared";

export const StickyBuyBar = ({ onBuy }) => {
  const { scrollY } = useScroll();
  const [visible, setVisible] = useState(false);
  useMotionValueEvent(scrollY, "change", (v) => {
    setVisible(v > window.innerHeight * 0.95);
  });

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-buy-bar"
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-carbon/80 backdrop-blur-xl"
        >
          <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-4 px-5 py-3 md:px-10">
            <div className="flex items-center gap-4">
              <img
                src="/assets/cj-1.jpg"
                alt="X8 Violent Fan thumbnail"
                className="hidden h-11 w-11 border border-steel object-cover sm:block"
              />
              <div>
                <div className="font-display text-xs font-bold uppercase tracking-wider">X8 Violent Fan</div>
                <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-smoke">
                  <span className="text-volt">${PRICE}</span>{" "}
                  <span className="line-through">$69.99</span> — +$4.99 shipping
                </div>
              </div>
            </div>
            <button
              data-testid="sticky-buy-button"
              onClick={onBuy}
              className="flex items-center gap-2 border border-volt bg-volt px-6 py-3 font-mono text-xs font-bold tracking-[0.2em] uppercase text-ink transition-colors duration-200 hover:bg-transparent hover:text-volt"
            >
              <Zap className="h-4 w-4" />
              Buy now
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
